import React from "react";
import { Button, Card, CardBody } from "@heroui/react";
import PageTemplate from "../components/PageTemplate";

export default function Merch() {
  const merchItems = [
    {
      name: "T-Shirt",
      price: "$8",
      image: "/Merch/tshirt.png",
      sizes: "XS - XL"
    },
    {
      name: "Crewneck",
      price: "$15",
      image: "/Merch/crewneck.png",
      sizes: "XS - XL"
    },
    {
      name: "Sweatpants",
      price: "$20",
      image: "/Merch/sweatpants.png",
      sizes: "XS - XL"
    }
  ];

  return (
    <PageTemplate>
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-pink-100 via-coral-100 to-cream-100 py-8 sm:py-12 lg:py-16 px-4 sm:px-6 relative overflow-hidden">
        <div className="max-w-6xl mx-auto text-center relative z-10">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-text font-bold text-coral mb-4 sm:mb-6 animate-fade-in">
            NJ Naach 3.0 Merch
          </h1>
          <div className="w-16 sm:w-20 lg:w-24 h-1 bg-coral mx-auto rounded-full"></div>
        </div>
      </div>

      {/* Merch Grid */}
      <div className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 bg-cream-50">
        <div className="max-w-7xl mx-auto">
          {/* Merch Items */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 mb-12">
            {merchItems.map((item, index) => (
              <Card 
                key={index}
                className="bg-white/80 backdrop-blur-sm border border-peach-200 shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 animate-fade-in"
                style={{ animationDelay: `${index * 0.2}s` }}
              >
                <CardBody className="p-6">
                  {/* Product Image */}
                  <div className="relative h-64 sm:h-72 lg:h-80 mb-6 overflow-hidden rounded-xl bg-gradient-to-br from-cream-50 to-peach-50 flex items-center justify-center">
                    <img 
                      src={item.image} 
                      alt={item.name}
                      className="max-h-full max-w-full object-contain p-4"
                    />
                  </div>
                  
                  {/* Product Info */}
                  <div className="text-center">
                    <h3 className="text-2xl sm:text-3xl font-text font-bold text-coral mb-2">
                      {item.name}
                    </h3>
                    <p className="text-3xl sm:text-4xl font-bold text-coral-600 mb-2">
                      {item.price}
                    </p>
                    <p className="text-sm sm:text-base text-teal-600 font-text">
                      Sizes: {item.sizes}
                    </p>
                  </div>
                </CardBody>
              </Card>
            ))}
          </div>

          {/* Order Button */}
          <div className="text-center">
            <Button
              as="a"
              href="https://docs.google.com/forms/d/1QZS08-7u3dEUlxBZIS7jj6OZHC7Pz1__QlqBSKFBak0/edit"
              target="_blank"
              rel="noopener noreferrer"
              size="lg"
              className="bg-gradient-to-r from-coral to-teal text-white px-16 py-8 sm:px-20 sm:py-10 rounded-full font-button font-bold text-2xl sm:text-3xl md:text-4xl shadow-2xl hover:shadow-3xl hover:scale-110 transition-all duration-300 animate-pulse"
              style={{ animationDuration: '2s' }}
            >
              🛒 Order Here!
            </Button>
          </div>
        </div>
      </div>

      {/* Order Information */}
      <div className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 bg-cream-50">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-text font-bold text-coral text-center mb-8 sm:mb-12">
            How to Order
          </h2>
          
          <div className="max-w-2xl mx-auto">
            {/* Payment Info */}
            <Card className="bg-white/80 backdrop-blur-sm border border-peach-200 shadow-xl">
              <CardBody className="p-6 sm:p-8">
                <div className="text-5xl mb-4 text-center">💳</div>
                <h3 className="text-xl sm:text-2xl font-text font-bold text-coral mb-4 text-center">
                  Payment Methods
                </h3>
                <div className="space-y-3 text-teal-600 font-text">
                  <div className="bg-peach-50 rounded-lg p-3">
                    <p className="font-semibold text-teal-700">Zelle:</p>
                    <p className="text-sm sm:text-base">njnaach@gmail.com</p>
                  </div>
                  <div className="bg-sky-50 rounded-lg p-3">
                    <p className="font-semibold text-teal-700">Venmo:</p>
                    <p className="text-sm sm:text-base">@Himit-Shah</p>
                  </div>
                  <p className="text-sm text-teal-500 italic mt-4">
                    * Include your name and item purchased in the payment description
                  </p>
                </div>
              </CardBody>
            </Card>
          </div>

          {/* Important Notice */}
          <Card className="mt-8 bg-gradient-to-r from-coral-50 to-peach-50 border border-coral-200 shadow-lg">
            <CardBody className="p-6 text-center">
              <p className="text-base sm:text-lg text-teal-700 font-text">
                ⚠️ <span className="font-semibold">Important:</span> Orders will only be fulfilled once payment is received. 
                We will contact you with pickup details after your order is confirmed.
              </p>
            </CardBody>
          </Card>
        </div>
      </div>

      {/* Call to Action */}
      <div className="bg-gradient-to-r from-coral to-teal py-12 sm:py-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-text font-bold text-white mb-4 sm:mb-6">
            Rep Your Favorite Competition! 🌊
          </h2>
          <p className="text-lg sm:text-xl text-white/90 mb-6 sm:mb-8 font-text">
            Get your official NJ Naach 3.0 merch and support our amazing event!
          </p>
          <Button
            as="a"
            href="https://docs.google.com/forms/d/1QZS08-7u3dEUlxBZIS7jj6OZHC7Pz1__QlqBSKFBak0/edit"
            target="_blank"
            rel="noopener noreferrer"
            size="lg"
            className="bg-white text-teal-700 px-10 py-4 rounded-full font-button font-bold text-lg hover:bg-cream-50 transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105"
          >
            Order Your Merch Now! 🛍️
          </Button>
        </div>
      </div>
    </PageTemplate>
  );
}

